import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectFacilityState {
    facilitiesId: number[];
    loading: boolean;
    error: string | null;
}

const initialState: any = {
    facilitiesId: [],
    loading: false,
    error: null
};

const selectFacilitySlice = createSlice({
    name: 'facilities',
    initialState,
    reducers: {
        setFacilitiesId(state, action: PayloadAction<number[]>) {
            state.facilitiesId = action.payload;
        },
        resetFacilitiesId(state) {
            state.facilitiesId = [];
        }
    },
    extraReducers: (builder) => {

    }
});
export const { setFacilitiesId, resetFacilitiesId } = selectFacilitySlice.actions;
export default selectFacilitySlice.reducer;